export const CROP_MASTER_BASE = '/crop-master'

export const getCropMasterPath = () => CROP_MASTER_BASE

export const getAddCropPath = () =>
 `${CROP_MASTER_BASE}/add-crop`

export const getCropDetailsPath = (
 cropId: string | number
) => `${CROP_MASTER_BASE}/crop/${cropId}`
